export const LOGIN_SCOPES = 'email openid profile';
export const LOGIN_ADMIN_SCOPES =
    'email openid profile https://www.googleapis.com/auth/admin.directory.user https://www.googleapis.com/auth/admin.directory.user https://www.googleapis.com/auth/cloud-platform';
